var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tab-select',{staticClass:"parameter-tab-select",attrs:{"value":{ id: _vm.value || _vm.placeholderValue, content: _vm.value || _vm.placeholderValue },"items":_vm.items || _vm.prop.items.map(i => ({ id: i, content: i }))},on:{"input":function($event){return _vm.updateProp($event.id)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }